import React, { useEffect, useContext } from "react";
import { store } from "../../context/store";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { useHistory } from "react-router-dom";

import { COLOR_DASHBOARD_BACKGROUND } from "../../constants/colors";

export default function SpaceWorksettings() {

    const globalState = useContext(store);
    const { dispatch } = globalState;
    const history = useHistory();

    useEffect(() => {
        // Demo-only for now
    }, []);

    /* =========================
       STYLES
    ========================== */

    const thisContainer = {
        display: "flex",
        position: "fixed",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        left: "0px",
        top: "0px"
    };

    const mainContainer = {
        display: "flex",
        position: "fixed",
        top: "80px",
        left: "60px",
        bottom: "0px",
        right: "0px",
        flexDirection: "row",
        overflow: "hidden",
        backgroundColor: COLOR_DASHBOARD_BACKGROUND
    };

    const centrePanel = {
        flex: 1,
        padding: "40px",
        background: "linear-gradient(180deg, #f2f3f5 0%, #e6e8eb 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    };

    const rightDrawer = {
        width: "360px",
        backgroundColor: "#111",
        color: "#fff",
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        boxShadow: "inset 1px 0 0 rgba(255,255,255,0.08)"
    };

    const title = {
        fontSize: "22px",
        fontWeight: 600,
        marginBottom: "20px",
        letterSpacing: "0.3px"
    };

    /* =========================
       DEMO DATA
    ========================== */

    const mainPieData = [
        { label: "Focus", value: 40, color: "#4a90e2" },
        { label: "Collaboration", value: 35, color: "#50e3c2" },
        { label: "Support", value: 15, color: "#f5a623" },
        { label: "Other", value: 10, color: "#9b9b9b" }
    ];

    const sidePies = [
        {
            title: "By Department",
            data: [
                { label: "Tech", value: 45 },
                { label: "Ops", value: 30 },
                { label: "HR", value: 15 },
                { label: "Other", value: 10 }
            ]
        },
        {
            title: "By Activity",
            data: [
                { label: "Desk Work", value: 50 },
                { label: "Meetings", value: 30 },
                { label: "Breakout", value: 20 }
            ]
        },
        {
            title: "By Condition",
            data: [
                { label: "Good", value: 70 },
                { label: "Fair", value: 20 },
                { label: "Poor", value: 10 }
            ]
        }
    ];

    /* =========================
       SIMPLE PIE RENDERERS
    ========================== */

    function Pie({ size, data }) {
        let cumulative = 0;

        return (
            <svg width={size} height={size} viewBox="0 0 32 32">
                {data.map((slice, i) => {
                    const start = cumulative;
                    const value = slice.value / 100;
                    cumulative += value;

                    const startAngle = start * 2 * Math.PI;
                    const endAngle = cumulative * 2 * Math.PI;

                    const x1 = 16 + 16 * Math.cos(startAngle);
                    const y1 = 16 + 16 * Math.sin(startAngle);
                    const x2 = 16 + 16 * Math.cos(endAngle);
                    const y2 = 16 + 16 * Math.sin(endAngle);

                    const largeArc = value > 0.5 ? 1 : 0;

                    const pathData = `
                        M16 16
                        L${x1} ${y1}
                        A16 16 0 ${largeArc} 1 ${x2} ${y2}
                        Z
                    `;

                    return (
                        <path
                            key={i}
                            d={pathData}
                            fill={slice.color || "#666"}
                        />
                    );
                })}
            </svg>
        );
    }

    function SidePie({ title, data }) {
        return (
            <div>
                <div style={{ fontSize: "14px", fontWeight: 600, marginBottom: "8px" }}>
                    {title}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                    <Pie size={90} data={data.map(d => ({ ...d, color: "#4a90e2" }))} />
                    <div style={{ fontSize: "12px", lineHeight: "18px", opacity: 0.85 }}>
                        {data.map((d, i) => (
                            <div key={i}>
                                {d.label} – {d.value}%
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    /* =========================
       RENDER
    ========================== */

    return (
        <div style={thisContainer}>
            <Header />
            <LeftMenu />

            <div style={mainContainer}>

                {/* CENTRE */}
                <div style={centrePanel}>
                    <div style={title}>Space Worksettings Overview</div>
                    <Pie size={280} data={mainPieData} />
                </div>

                {/* RIGHT DRAWER */}
                <div style={rightDrawer}>
                    {sidePies.map((p, i) => (
                        <SidePie key={i} title={p.title} data={p.data} />
                    ))}
                </div>

            </div>
        </div>
    );
}